<template>
  <div class="dataRight">
    <div class="stateTable">
      <el-scrollbar>
        <ChangeTime ref="changeTime"></ChangeTime>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import CheckAnalysis from "./CheckAnalysis.js";
export default CheckAnalysis;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
